import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import LKModal from '../Modal/Modal';
import './PowerUpdate.scss';

class PowerUpdate extends PureComponent {
    static propTypes = {
        hitPowerAPI: PropTypes.func,
        getPowerUpdate: PropTypes.func
    }

    constructor(props) {
        super(props);
        this.phoneNo = React.createRef();
        this.state = {
            invalidPhoneNumber: false,
            shouldShowError: false
        };
        this.validatePhoneNumber = this.validatePhoneNumber.bind(this);
    }

    validatePhoneNumber = () => {
        const phoneVal = this.phoneNo.current.value;
        const regexPhone = /^[0]?[789]\d{9}$/;
        if (regexPhone.test(phoneVal)) {
            this.props.hitPowerAPI(phoneVal);
        } else {
            this.setState({ invalidPhoneNumber: true });
        }
        this.setState({ shouldShowError: true });
    }

    render() {
        const { showModal, hideHandler, enterPowerRespMsg, dataLocale } = this.props;
        let localConfig = {
            backdrop: true,
            keyboard: true
        };
        localConfig = Object.assign({}, localConfig);
        const { SUBMIT_PRESCRIPTION_FOR_EXISTING_ORDER, ENTER_PHONE_NUMBER, SUBMIT, PLEASE_ENTER_VALID_PHONE_NUMBER } = dataLocale;
        return (
            <LKModal {...localConfig} hideHandler={() => hideHandler()} showModal={showModal} headerTitle={ENTER_PHONE_NUMBER}>
                <div className="powerUpdateModal">
                    <div className="powerUpdateModal_desc">
                        {SUBMIT_PRESCRIPTION_FOR_EXISTING_ORDER}
                        <div className="powerUpdateModal_formControls">
                            <input ref={this.phoneNo} type="text" className="form-control" id="phoneNo" placeholder={ENTER_PHONE_NUMBER} />
                        </div>
                    </div>
                    <button
                        type="button"
                        className="powerUpdateModal_btn"
                        data-dismiss="modal"
                        onClick={() => {
                            this.setState({
                                invalidPhoneNumber: false
                            });
                            this.validatePhoneNumber();
                        }}
                    >{SUBMIT}</button>
                    <div className="powerUpdateModal_pfError">
                        {this.state.shouldShowError && this.state.invalidPhoneNumber && <div className="powerUpdateModal_pfError_error alert alert-danger">{PLEASE_ENTER_VALID_PHONE_NUMBER}</div>}
                        {this.state.shouldShowError && enterPowerRespMsg && !this.state.invalidPhoneNumber && <div className="powerUpdateModal_pfError_error alert alert-danger" dangerouslySetInnerHTML={{ __html: enterPowerRespMsg }}></div>}
                    </div>
                </div>
            </LKModal>
        );
    }
}

export default PowerUpdate;





